const defaultApiEndpoint = process.env.NODE_ENV === 'production'
  ? 'https://apiprd.nobreimagens.com.br/api'
  : 'http://localhost:8001/api'

const apiEndpoint = (process.env.REACT_APP_API_URL || defaultApiEndpoint)
  .replace(/\/+$/, '')

export default {
  loginEndpoint: `${apiEndpoint}/login`,
  registerEndpoint: `${apiEndpoint}/register`,
  refreshEndpoint: `${apiEndpoint}/refresh-token`,
  logoutEndpoint: `${apiEndpoint}/logout`,
  baseApi: apiEndpoint.replace(/\/api$/, ''),
  apiEndpoint,
  tokenType: 'Bearer',
  storageTokenKeyName: 'sessionToken',
  storageRefreshTokenKeyName: 'sessionTokenexpiration'
}
